import React, { useState, useCallback } from 'react';
import { Save, RefreshCw, Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import SettingsLayout from '../../../components/Admin/Settings/SettingsLayout';
import BranchSettings from '../../../components/Admin/Settings/BranchSettings';

/**
 * Branch Settings Page
 *
 * Manage restaurant/branch information including name, address,
 * tax info (GST, FSSAI), and branding (logo, thank you message).
 * Action buttons are rendered in the sticky header.
 */
export default function BranchSettingsPage() {
  const [componentActions, setComponentActions] = useState(null);

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  // Action buttons for the header
  const headerActions = componentActions ? (
    <>
      {/* Status indicator */}
      {componentActions.hasChanges ? (
        <span className="flex items-center gap-1.5 text-xs text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full border border-amber-200">
          <AlertCircle size={12} />
          Unsaved
        </span>
      ) : (
        <span className="flex items-center gap-1.5 text-xs text-teal-600 bg-teal-50 px-2.5 py-1 rounded-full border border-teal-200">
          <CheckCircle size={12} />
          Saved
        </span>
      )}

      <div className="h-5 w-px bg-slate-200" />

      <button
        onClick={componentActions.onRefresh}
        disabled={componentActions.saving}
        className="p-1.5 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 border border-slate-200 disabled:opacity-50"
      >
        <RefreshCw size={16} />
      </button>
      <button
        onClick={componentActions.onSave}
        disabled={componentActions.saving || !componentActions.hasChanges}
        className="px-3 py-1.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {componentActions.saving ? (
          <>
            <Loader2 size={14} className="animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Save size={14} />
            Save
          </>
        )}
      </button>
    </>
  ) : null;

  return (
    <AdminLayout>
      <SettingsLayout actions={headerActions}>
        <BranchSettings renderActions={handleActionsReady} />
      </SettingsLayout>
    </AdminLayout>
  );
}
